import { ROUTES } from '../constants/RouteNameMapping';

/** The modules a fund admin cannot open, by their first URL segment: the API closes their data (FD-5905). */
export const FUND_ADMIN_CLOSED_SECTIONS: ReadonlySet<string> = new Set([
  ROUTES.COMPANIES,
  ROUTES.SOURCING,
  ROUTES.ENTITIES,
  ROUTES.DEAL_FLOW,
  ROUTES.DOCS,
  ROUTES.KPI,
]);

/** Whether a path, with or without its leading slash, opens a module closed to a fund admin. */
export function isClosedToFundAdmin(path: string): boolean {
  return FUND_ADMIN_CLOSED_SECTIONS.has(path.replace(/^\//, '').split('/')[0]);
}
